import Axios from 'axios';
import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import JobCard from '../../components/job_card/job_card.vue';
import moment from 'moment'

export default Vue.extend({
    components: {
        Confirm,
        JobCard
    },

    data: () => ({
      jobs : [],
      dataLoading : false 
    }),

    created(){
      this.all_job();
    },

    methods:{
      async all_job(){
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        this.dataLoading = true;
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let resp = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
          console.log(resp);
          if (resp.status === 200 && resp.data.message === "Jobs found"){
            this.jobs = resp.data.jobs;
            for (let i = 0; i < this.jobs.length; i++) {
              for (let j = 0; j < this.jobs[i].exam_dates.length; j++) {
                // let date = new Date(this.jobs[i].exam_dates[j] * 1000);
                // this.jobs[i].exam_dates[j] = date.getDate()+"-"+(date.getMonth()+1)+"-"+date.getFullYear()+
                //                 " "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds()+'0';
                //                 moment().format('MMMM Do, YYYY h:mm a');
                var day = moment.unix(this.jobs[i].exam_dates[j]);
                this.jobs[i].exam_dates[j] = day.format('MMMM Do YYYY, h:mm a')
              }
            }
            console.log(this.jobs);
          }
          this.dataLoading = false;
        }
      },

      go_to_talent(id){
        this.$router.push({ name: 'recomended_talent', params: { id: id } })
      },

      go_to_jdetails(jid){
        this.$router.push({ name: 'job-application-details', params: { id: jid } })
      },

      backPage() {
        window.history.back()
      },

      edit(jid){
        this.$router.push({ name: 'update_job-application', params: { id: jid } })
      },

      // async job_delete(id){
      //   try {
      //     if (await this.$refs.confirm.open('Remove Job', 'Are you sure?', {color: 'black'})) {

      //       let token = localStorage.getItem("jwt");
      //       let userId = localStorage.getItem("userId");

      //       console.log(token);
      //       console.log(userId);

      //       if (token && userId) { 
      //         const auth = {
      //           headers: {authorization: token} 
      //         }  
      //         let res = await this.$http.post('/job/removeJob',{
      //             job_id: id,
      //             user_id: userId
      //         },auth);
      //         if (res.status === 200 && res.data.message === "Job removed successfully") {
      //           console.log("jhjhggyugyggygy");
      //           this.snackbar = true;
      //           this.showMessage = 'Removed Successfully.'
      //           this.all_job();
      //         } else {
      //           this.snackbar = true;
      //           this.showMessage = 'Something wrong! Please try again.'
      //         }
      //       }
      //     }
      //   }catch(error){}
      // },


      async job_delete(id){
        try {
          //  await this.alertMsg('Remove Job','info','Are you sure?',id)
           this.$swal({
            title: 'Remove Job',
            text: 'Are you sure?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText:'Cancel',
            customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_job(id);
          }
         
        })

        }catch(error){}
      },

    
      async delete_job(id){
        let token = localStorage.getItem("jwt");
        let userId = localStorage.getItem("userId");

        console.log(token);
        console.log(userId);

        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let res = await this.$http.post('/job/removeJob',{
              job_id: id,
              user_id: userId
          },auth);
          if (res.status === 200 && res.data.message === "Job removed successfully") {
            console.log("jhjhggyugyggygy");
            this.snackbar = true;
            this.showMessage = 'Removed Successfully.'
            this.all_job();
          } else {
            this.snackbar = true;
            this.showMessage = 'Something wrong! Please try again.'
          }
        }
      }
    }
  })